import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { bunader } from "@/data/bunader";
const Products = () => {
  return <section id="drakter" aria-labelledby="products-heading" className="section-padding bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-primary font-sans text-xs tracking-[0.3em] uppercase mb-4">
            Vårt utvalg
          </p>
          <h2 id="products-heading" className="font-serif text-3xl md:text-4xl lg:text-5xl text-foreground mb-6">Våre drakter</h2>
          <p className="text-muted-foreground font-sans">
            Vi tilbyr et utvalg av nøye utvalgte bunader og drakter, 
            alle skreddersydd og produsert i Norge.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {bunader.map(bunad => <Link key={bunad.id} to={`/drakt/${bunad.id}`} className="group block">
              <div className="relative aspect-[3/4] bg-cream overflow-hidden mb-4">
                {bunad.images.length > 0 ? <img src={bunad.images[0]} alt={bunad.title} className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105" /> : <div className="absolute inset-0 bg-gradient-to-br from-muted to-secondary flex items-center justify-center">
                    <span className="font-serif text-3xl text-foreground/20 group-hover:text-primary/30 transition-colors duration-500">
                      {bunad.title.charAt(0)}
                    </span>
                  </div>}
                <div className="absolute inset-0 bg-foreground/0 group-hover:bg-foreground/5 transition-colors duration-500" />
              </div>
              <h3 className="font-serif text-xl text-foreground mb-2 group-hover:text-primary transition-colors">
                {bunad.title}
              </h3>
              <span className="inline-flex items-center gap-2 text-primary font-sans text-sm tracking-wide group-hover:gap-3 transition-all">
                Les mer <ArrowRight className="w-4 h-4" />
              </span>
            </Link>)}
        </div>

        <p className="text-center text-muted-foreground text-sm mt-12 font-sans">
          <strong className="text-foreground">Alle våre bunader er norskprodusert</strong>, 
          og vi bruker kun norske materialer. Alle bunader blir tilpasset hver enkelt kunde.
        </p>
      </div>
    </section>;
};
export default Products;